import { render, staticRenderFns } from "./BaseNotificationsIcon.vue?vue&type=template&id=7c8d86da"
import script from "./BaseNotificationsIcon.vue?vue&type=script&lang=js"
export * from "./BaseNotificationsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports